module.exports = __webpack_public_path__ + "media/audio23.b54b3284.mp3";